import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { employeeService } from '../../services/employeeService';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/formatters';

const Attendance = () => {
  const queryClient = useQueryClient();
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  const { data, isLoading } = useQuery(
    ['attendance', selectedDate],
    () => employeeService.getAttendance({ date: selectedDate })
  );

  const markAttendanceMutation = useMutation(
    (attendanceData) => employeeService.markAttendance(attendanceData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['attendance', selectedDate]);
        toast.success('Attendance marked successfully');
      }
    }
  );

  const employees = data?.data || [];

  const handleMarkAttendance = (employeeId, status) => {
    markAttendanceMutation.mutate({
      employee_id: employeeId,
      status: status,
      attendance_date: selectedDate
    });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Employee Attendance</h1>

      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Select Date</label>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />
      </div>

      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employee</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Department</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {employees.map((employee) => (
                <tr key={employee.id}>
                  <td className="px-6 py-4">
                    <div className="font-medium">{employee.name}</div>
                    <div className="text-sm text-gray-500">{employee.employee_code}</div>
                  </td>
                  <td className="px-6 py-4">{employee.designation || 'N/A'}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      employee.attendance_status === 'present' ? 'bg-green-100 text-green-800' :
                      employee.attendance_status === 'absent' ? 'bg-red-100 text-red-800' :
                      employee.attendance_status === 'late' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {employee.attendance_status || 'Not Marked'}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex space-x-2">
                      <button
                        onClick={() => handleMarkAttendance(employee.id, 'present')}
                        className="px-3 py-1 bg-green-500 text-white rounded text-sm hover:bg-green-600"
                      >
                        Present
                      </button>
                      <button
                        onClick={() => handleMarkAttendance(employee.id, 'absent')}
                        className="px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600"
                      >
                        Absent
                      </button>
                      <button
                        onClick={() => handleMarkAttendance(employee.id, 'late')}
                        className="px-3 py-1 bg-yellow-500 text-white rounded text-sm hover:bg-yellow-600"
                      >
                        Late
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Attendance;